export const TIPO_TRANSACAO = {
	ENTRADA: 'Entrada',
	SAIDA: 'Saída',
	MOVIMENTACAO: 'Movimentação',
	RESERVA_PDR: 'Reserva-PDR',
	SAIDA_PDR: 'Saída-PDR',
	DEVOLUCAO: 'Devolução',
	DESCARTE: 'Descarte',
	EMPRESTIMO: 'Empréstimo',
};
